import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { FaceRecognitionUIRoutingModule } from './faceRecognitionUI-routing.module';


@NgModule({
  exports: [
    FaceRecognitionUIRoutingModule
  ],
  declarations: [],
  imports: [
    CommonModule,
    FaceRecognitionUIRoutingModule,
  ],
  providers: [],

})
export class FaceRecognitionUIModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: FaceRecognitionUIModule,
      providers: []
    };
  }
}
